import React, { useEffect, useState } from "react";
import "./fleets-details.scss";
import dayjs from "dayjs";
import {
  Row,
  Col,
  Card,
  Tag,
  Button,
  Table,
  Input,
  Divider,
  Space,
  Dropdown,
  Spin,
  Modal,
  Form,
  Select,
  Typography,
  Collapse,
} from "antd";
import { EditOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import MapButtonIcon from "../../assets/images/maps-square-button.svg";
import TruckWithBox from "../../assets/images/truck-with-box.svg";
import TruckWithGrill from "../../assets/images/Grill-truck.svg";
import EmptyTruck from "../../assets/images/Flatted-truck.svg";
import UaeFlag from "../../assets/images/uae-flag.svg";
import TurkeyFlag from "../../assets/images/Turkey-flag.svg";
import sortImg from "../../assets/images/sort-image.svg";
import DocFileImg from "../../assets/images/Doc-Content.svg";
import EditImg from "../../assets/images/pencil-edit.svg";
import * as driverService from "../../service/fleet-management/driverService";
import * as truckService from "../../service/fleet-management/truckService";
import Notification from "../../service/notification";
import moment from "moment";
import DriverGruardImg from "../../assets/images/driver-guard-img.svg";
import ArrowUp from "../../assets/images/arrow-up-dropdown.svg";
import Arrowdown from "../../assets/images/arrow-down-dropdown.svg";
import { CheckCircleOutlined, MoreOutlined } from "@ant-design/icons";
import AlertCircle from "../../assets/images/alert-circle.svg";
import uploadIcon from "../../assets/images/upload-icon.svg";
import AddTruck from "./add-truck";
import AddDriver from "./add-driver";
import { json, useNavigate, useParams } from "react-router-dom";
import Notifications from "../../service/notification";
import { useTranslation } from "react-i18next";
import * as otpService from "../../service/otpService";
import {
  CommonConstants,
  DocTypes,
  EntityTypes,
} from "../../constants/commonConstants";
import { LocalStorageKeys } from "../../constants/localStorageKeys";
import * as localStorageService from "../../service/localStorageService";
import NodataImg from "../../assets/images/nodata-img.svg";
import { useStore } from "../../store/store";
import {
  checkIsBroker,
  checkIsFleetOwner,
  checkIsFleetOwnerConverted,
  checkIsInternalSourcing,
  checkIsSTO,
} from "../../util/constantUtility";
import * as documentUtility from "../../util/documentThumbUtility";
import Fileupload from "../../common/fileupload/fileupload";
import debounce from "lodash/debounce";
import { useLocation } from "react-router-dom";
import fileSearchGif from "../../../src/assets/images/file-search.gif";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { BrandColors } from "../../constants/brand";

const { Text } = Typography;

const FleetDetails = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { t } = useTranslation();
  const { user, saveUser } = useStore();
  const [uploadImageForm] = Form.useForm();
  let { driverORTruckId, supplierId, supplierName } = useParams();
  const [detailData, setDetailData] = useState(null);
  const fleetType =
    driverORTruckId?.split("-")[0] === "driver" ? "Driver" : "Truck";
  const driverORTruckIdValue = driverORTruckId?.split("-")[1];
  const [driverDocs, setDriverDocs] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [verifyModal, setVerifyModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [btnLoader, setBtnLoader] = useState(false);
  const [form] = Form.useForm();
  const language = localStorageService.getValue(LocalStorageKeys.Lang)
    ? localStorageService.getValue(LocalStorageKeys.Lang)
    : CommonConstants.DefaultLanguageCode;
  const [otpDetails, setOtpDetails] = useState(null);
  const [timer, setTimer] = useState(120);
  const [isOTPRequested, setIsOtpRequested] = useState(false);
  const [tableToggle, setTableToggle] = useState(false);
  const [imageUploadLoader, setImageUploadLoader] = useState(false);
  const [applySearch, setApplySearch] = useState(false);
  const [isUploadImage, setIsUploadImage] = useState(false);
  const [saveProfileLoader, setSaveProfileLoader] = useState(false);

  const { Panel } = Collapse;
  const pageSize = 10;
  let pageNum = 1;
  const [triptableLoader, setTriptableLoader] = useState(false);
  const [tripTableSortOrder, setTripTableSortOrder] = useState("asc");
  const [tripTableData, setTripTableData] = useState([]);
  const [tableSearchText, setTableSearchText] = useState("");
  const [tripdetialListPagination, setTripdetialListPagination] = useState({
    currentPage: 1,
    totalRecord: 0,
    startIndex: 0,
    endIndex: 0,
    sortColumn: null,
  });
  const [driverData, setDriverData] = useState();
  const location = useLocation();
  const driver = location.state?.driver;

  const handleOpenModal = () => setAddModalOpen(true);
  const handleCloseModal = () => setAddModalOpen(false);

  // OCR STATES
  const initialUploadState = {
    progress: 0,
    status:t("OCR_MODAL_HOLD_TIGHT_MSG"),
    description: "Please don’t close or refresh the screen",
    started: false,
  };
  const [isUploadingPopupVisible, setIsUploadingPopupVisible] = useState(false);
  const [uploadState, setUploadState] = useState(initialUploadState);

  const documentTypeTranslationKeys = {
    "Driving License": "FLEET_DRIVER_DRIVING_LICENSE",
    "Driving License Number": "FLEET_DRIVER_DRIVING_LICENSE_NO",
    Passport: "FLEET_DRIVER_PASSPORT",
    "Passport Number": "FLEET_DRIVER_PASSPORT_NO",
    Visa: "FLEET_DRIVER_VISA",
    "Visa Number": "FLEET_DRIVER_VISA_NO",
    "National ID": "FLEET_DRIVER_NATIONAL_ID",
    "National ID Number": "FLEET_DRIVER_NATIONAL_ID_NO",
  };

  const translatedKeys = (item) => t(documentTypeTranslationKeys[item] || item);

  useEffect(() => {
    getData();
    getTripDetails(1, driverORTruckIdValue);
    setDriverData(driver);
  }, []);

  useEffect(() => {
    if (applySearch) {
      getTripDetails(
        tripdetialListPagination.currentPage,
        driverORTruckIdValue
      );
      setApplySearch(false);
    }
  }, [applySearch]);

  const getData = () => {
    if (fleetType === "Driver") {
      setLoader(true);
      driverService
        .getDriverDetails(driverORTruckIdValue, supplierId ?? "")
        .then((response) => {
          if (response.status === 200) {
            setDetailData(response?.data?.data);
            const { drivingLicense, nationalID, passport, visa } =
              response?.data?.data || {};
            // Combine all documents into one array
            const allDocs = [
              { type: "Driving License", ...drivingLicense },
              { type: "National ID", ...nationalID },
              { type: "Passport", ...passport },
              ...visa.map((v) => ({ type: "Visa", ...v })),
            ];
            setLoader(false);
            setDriverDocs(allDocs);
          }
        })
        .catch((error) => {});
    } else {
      setLoader(true);
      truckService
        .getTruckDetails(driverORTruckIdValue, supplierId ?? "")
        .then((response) => {
          if (response.status === 200) {
            setDetailData(response?.data?.data);
            setLoader(false);
          }
        })
        .catch((error) => {});
    }
  };

  useEffect(() => {
    let interval;
    if (isOTPRequested && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    if (timer === 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [isOTPRequested, timer]);

  const onProfilePictureUpload = (file, fieldName) => {
    uploadImageForm.setFieldsValue({
      [fieldName]: {
        docType: DocTypes.PROFILE_PIC,
        fileName: file.FileName,
        fileThumbName: file.FileThumbName,
        fileUrl: file.FileURL,
        size: file.size,
        fileThumbUrl: file.FileThumbURL,
      },
    });
  };
  const getTripDetails = (pageNum, driverORTruckIdValue) => {
    setTriptableLoader(true);
    let payload = {
      truckOrDriverId: driverORTruckIdValue,
      searchText: tableSearchText,
      sortOrder: tripTableSortOrder,
      type: fleetType,
      pageNumber: pageNum,
      pageSize: 10,
    };

    truckService
      .getTripDetails(payload)
      .then((response) => {
        if ((response.data.status = 200)) {
          setTriptableLoader(false);
          console.log(response.data.data);
          setTripTableData(response.data.data);
          let currentPagination = { ...tripdetialListPagination };
          currentPagination.currentPage = pageNum;

          if (response.data.data != undefined) {
            currentPagination.totalRecord =
              response.data.pagination.totalRecords;
          }

          //set start index and end index for display total record
          currentPagination.startIndex = (pageNum - 1) * pageSize + 1;
          let lastPageRecordIndex = pageNum * pageSize;
          currentPagination.endIndex = Math.min(
            lastPageRecordIndex,
            currentPagination.totalRecord
          );

          setTripdetialListPagination(currentPagination);
        }
      })
      .catch(() => {
        setTriptableLoader(false);
      });
  };

  const verifyNowHandler = async () => {
    let token = "";
    try {
      token = await executeRecaptcha("otp_request_action");
      console.log("RECAPTCHA TOKEN:", token);
    } catch (recaptchaError) {
      console.error("reCAPTCHA failed:", recaptchaError);
      Notification.error("reCAPTCHA verification failed. Please try again.");
      setIsOtpRequested(false);
      return;
    }
      console.log("RECAPTCHA TOKEN: ", token);

    const payload = {
      countryCode: detailData?.countryCode,
      mobileNo: detailData?.mobileNumber,
      otpType: "OtpSend",
      languageISOCode: language,
      captchaToken: token,
    };
    setVerifyModal(true);
    otpService
      .sendOTP(payload)
      .then((response) => {
        if (response.status === 200) {
          setOtpDetails(response?.data);
          localStorageService.setKey(
            LocalStorageKeys.UniqueId,
            response?.data?.data
          );
          Notification.success(
            t("SUCCESS_KEY"),
            `${t("OTP_SENT_TO_SUCCESS")} ${detailData?.mobileNumber}`
          );

          setIsOtpRequested(true);
          setTimer(120);
        }
      })
      .catch((error) => {
        setIsOtpRequested(false);
      });
  };

  const onResendOTP = async () => {
    const uniqueId = otpDetails?.data;

    if (timer === 0) {
      //  Recaptcha Token for resend
      let token = "";
      try {
        token = await executeRecaptcha("otp_request_action"); 
        console.log("RECAPTCHA TOKEN:", token);
      } catch (recaptchaError) {
        console.error("reCAPTCHA failed:", recaptchaError);
        Notification.error("reCAPTCHA verification failed. Please try again.");
        setIsOtpRequested(false);
        return;
      }

      const payload = {
        uniqueId: otpDetails?.data,
        countryCode: detailData?.countryCode,
        otpType: "OtpSend",
        languageISOCode: language,
        captchaToken: token
      };
      otpService
        .resendOTP(payload)
        .then((response) => {
          if (response?.status === 200) {
            setTimer(120);
            setIsOtpRequested(true);
            setOtpDetails(response?.data);
            localStorageService.setKey(LocalStorageKeys.UniqueId, uniqueId);
            Notification.success(
              t("SUCCESS_KEY"),
              `${t("OTP_SENT_TO_SUCCESS")}  ${detailData?.mobileNumber}`
            );
          }
        })
        .catch((error) => {});
    }
  };

  const verifyOTPHandler = () => {
    const payload = {
      otpDetails: {
        otpNumber: form.getFieldValue("otpNumber"),
        uniqueId: otpDetails?.data,
      },
      userId: detailData?.driverId,
      userRole: "Driver",
    };
    driverService
      .verifyDriverMobile(payload)
      .then((response) => {
        if (response.status === 200) {
          Notification.success(t("SUCCESS_KEY"), t("OTP_VERIFIED_SUCCESS"));
          setVerifyModal(false);
            getData();
        }
      })
      .catch((error) => {});
  };

  const reDirectToOrder = (orderId) => {
    navigate(`/orders/${orderId}`);
  };

  const columns = [
    {
      title: t("FLEET_TRUCKS_ORDER_ID"),
      dataIndex: "orderNumber",
      render: (text) => (
        <a
          onClick={() => reDirectToOrder(text)}
          style={{
            color: "var(--brand-primary-strong)",
            textDecoration: "underline",
            fontWeight: "bold",
          }}
        >
          {text}
        </a>
      ),
    },
    {
      title: t("FLEET_TRUCKS_PICK_UP"),
      dataIndex: "fromCity",
    },
    {
      title: t("FLEET_TRUCKS_DROP"),
      dataIndex: "toCity",
    },
    {
      title: t("FLEET_TRUCKS_MOVE_DATE"),
      dataIndex: "moveDate",
      render: (text, record) => {
        return <>{moment.utc(record.moveDate).format("DD MMM YYYY, h:mm A")}</>;
      },
    },
    {
      title: t("FLEET_TRUCKS_COMPLETION_DATE"),
      dataIndex: "completionDate",
      render: (text, record) => {
        return (
          <>
            {record.completionDate
              ? moment(record.completionDate).format("DD MMM YYYY, h:mm A")
              : "-"}
          </>
        );
      },
    },
    {
      title: t("FLEET_TRUCKS_TRIP_STATUS"),
      dataIndex: "status",
      render: (status) => (
        <Tag
          style={{
            color: status === "Completed" ? "#287D3C" : BrandColors.primary,
            backgroundColor: status === "Completed" ? "#EDF9F0" : BrandColors.primaryTint,
          }}
        >
          {status}
        </Tag>
      ),
    },
  ];
  const saveProfilePicture = () => {
    const profileValues = uploadImageForm.getFieldValue("uploadImage");
    setSaveProfileLoader(true);
    form
      .validateFields()
      .then(() => {
        let payload = {
          driverId: detailData?.driverId,
          profilePicture: {
            isInsertUpdate: true,
            documentPath: profileValues?.fileUrl
              ? profileValues?.fileUrl
              : null,
            documentPathThumb: profileValues?.fileThumbUrl
              ? profileValues?.fileThumbUrl
              : null,
            fileName: profileValues?.fileName ? profileValues?.fileName : null,
            isPathSet: true,
          },
        };

        driverService
          .driverProfilePicUpload(payload)
          .then((response) => {
            setSaveProfileLoader(false);
            getData();
            Notification.success(
              t("PROFILE_PIC_KEY"),
              t("PROFILE_PIC_UPDATE_SUCCESS")
            );
          })
          .catch((error) => {
            setSaveProfileLoader(false);
          });
      })
      .catch((error) => {
        setSaveProfileLoader(false);
      });
  };
  const handleUploadProfile = () => {
    setImageUploadLoader(true);
    const uploadedFile = uploadImageForm.getFieldValue("uploadImage");
    if (!uploadedFile || !uploadedFile.fileUrl) {
      uploadImageForm.setFields([
        {
          name: "uploadImage",
          errors: [t("UPLOAD_PROFILE_PIC_MSG")],
        },
      ]);

      setImageUploadLoader(false);
      return;
    }
    setTimeout(() => {
      saveProfilePicture();
      console.log(uploadImageForm.getFieldsValue(), "uploadimg payload");
      setImageUploadLoader(false);
      setIsUploadImage(false);
    }, 2000);
  };

  const handleMenuClick = (e) => {
    if (fleetType === "Driver") {
      const payload = {
        externalDriverId: detailData?.driverId,
        supplierId: supplierId ? supplierId : "",
      };
      driverService
        .RemoveDriverFromFleet(payload)
        .then((response) => {
          if (response.status === 200) {
            {
              checkIsInternalSourcing(user?.userRole)
                ? navigate(`/supplier-fleet/${supplierId}/${supplierName}`)
                : navigate("/fleet-management");
            }
            Notifications.success(
              t("SUCCESS_KEY"),
              t("DRIVER_REMOVED_SUCCESS")
            );
          }
        })
        .catch((error) => {});
    } else {
      const payload = {
        externalTruckId: detailData?.truckId,
        supplierId: supplierId ? supplierId : "",
      };
      truckService
        .RemoveTruckFromFleet(payload)
        .then((response) => {
          if (response.status === 200) {
            {
              checkIsInternalSourcing(user?.userRole)
                ? navigate(`/supplier-fleet/${supplierId}/${supplierName}`)
                : navigate("/fleet-management");
            }
            Notifications.success(t("SUCCESS_KEY"), t("TRUCK_REMOVED_SUCCESS"));
          }
        })
        .catch((error) => {});
    }
  };

  const handleFormChange = (field, val, option) => {
    form.setFieldValue(field, val);
    form.validateFields();
  };

  const handleSort = () => {
    setTripTableSortOrder((prevOrder) =>
      prevOrder === "asc" ? "desc" : "asc"
    );
    setApplySearch(true);
  };

  const handleSearch = debounce((e) => {
    setTableSearchText(e.target.value);
    setApplySearch(true);
    // setPageNumber(1); // Reset to first page on search
  }, 500);

  const getRegistrationCountryCode = (country) => {
    switch (country) {
      case "United Arab Emirates":
        return "UAE";
      case "Saudi Arabia":
        return "KSA";
      case "Bahrain":
        return "BHR";
      case "Turkey":
        return "TUR";
      case "Oman":
        return "OMN";
      case "Jordan":
        return "JOR";
      case "Kazakhstan":
        return "KAZ";
      case "Egypt":
        return "EGP";
      case "Poland":
        return "POL";
      case "India":
        return "IND";
      default:
        return country;
    }
  };

  return (
    <>
      <div className="container-fleet-details">
        {loader ? (
          <div className="loader">
            <Spin />
          </div>
        ) : (
          <div>
            <Row gutter={16} className="card-row">
              <Col span={12} className="flex-column">
                <Card
                  className="card-truck"
                  // detailData?.countryCode!==user?.countryCode
                  title={
                    <div className="card-title">
                      {t("FLEET_TRUCKS_BASIC_INFORMATION")}
                    </div>
                  }
                  extra={
                    (fleetType === "Truck" ||
                      //((fleetType === "Driver") && checkIsFleetOwner(user.userRole)) ||
                      //((fleetType === "Driver") && !checkIsSTO(user?.userRole) && ((checkIsBroker(user?.userRole) || checkIsFleetOwnerConverted(user?.userRole)) && !(detailData?.mobileNumber===user?.mobileNo && detailData?.countryCode===user?.countryCode))))
                      (fleetType === "Driver" &&
                        driverData?.isDeletable === true)) && (
                      <Dropdown
                        menu={{
                          items: [
                            {
                              key: "1",
                              label: t("FLEET_REMOVE_FROM_FLEET_BTN"),
                            },
                          ],
                          onClick: handleMenuClick,
                        }}
                      >
                        <MoreOutlined style={{ fontSize: "19px" }} />
                      </Dropdown>
                    )
                  }
                >
                  {fleetType === "Driver" ? (
                    <div className="overflow-check">
                      <div className="img-div">
                        {detailData?.profilePicture ? (
                          <img
                            src={detailData?.profilePicture?.documentPath}
                            alt="Profile Picture"
                            className="profile-image"
                          />
                        ) : (
                          <img src={DriverGruardImg} alt="Truck" />
                        )}

                        <button
                          className="save-btn-class"
                          onClick={() => setIsUploadImage(true)}
                        >
                          {/* {t("ACCOUNT_UPLOAD_IMAGE")} */}
                          {detailData?.profilePicture ? (
                            <img className="edit-icon" src={EditImg} />
                          ) : (
                            "📷"
                          )}
                        </button>
                        {/* &nbsp;&nbsp;<Button>{t("ACCOUNT_REMOVE")}</Button> */}
                      </div>
                      <div className="details-rows-driver">
                        <Row gutter={[8, 8]} className="data-row">
                          <Col span={8}>
                            <span>{t("FLEET_DRIVER_NAME")}</span>
                            <span>
                              {detailData?.name ? detailData?.name : "NA"}
                            </span>
                          </Col>
                          <Col span={8} className="verification-col">
                            <div>{t("FLEET_DRIVER_MOBILE_NO")}</div>
                            <div>
                              {"+"}
                              {detailData?.countryCode
                                ? detailData?.countryCode
                                : "NA"}{" "}
                              {detailData?.mobileNumber
                                ? detailData?.mobileNumber
                                : "NA"}
                            </div>
                            <div
                              className="verify-now"
                              onClick={verifyNowHandler}
                            >
                              {detailData?.isMobileNumberVerified
                                ? ""
                                : t("FLEET_VERIFY_NOW_BTN")}
                            </div>
                            {detailData?.isMobileNumberVerified ? (
                              <span style={{ color: "var(--text-success, #287D3C)" }}>
                                <CheckCircleOutlined /> {t("OTP_VERIFIED_KEY")}
                              </span>
                            ) : (
                              <span className="otp-not-verified">
                                <img src={AlertCircle} alt="" />{" "}
                                {t("NOT_VERIFIED_KEY")}
                              </span>
                            )}
                          </Col>
                          <Col span={8}>
                            <span>{t("FLEET_DRIVER_STATUS")}</span>
                            <span
                              className={
                                detailData?.statusText === "Available"
                                  ? t("AVAILABLE_STATUS_KEY")
                                  : detailData?.statusText === "Booked"
                                  ? t("BOOKED_STATUS_KEY")
                                  : t("WARNING_STATUS_KEY")
                              }
                            >
                              {detailData?.statusText
                                ? detailData?.statusText
                                : "NA"}
                            </span>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  ) : (
                    <div className="overflow-check">
                      <div className="img-div-truck">
                        <img src={detailData?.truckFilePath} alt="Truck" />
                      </div>
                      <div className="details-rows-truck">
                        <Row gutter={[8, 8]} className="data-row">
                          <Col span={8}>
                            <span>{t("FLEET_TRUCKS_PLATE_NO")}</span>
                            <Space className="country-detail">
                              <div className="country-name">
                                {detailData?.countryFlagPath && (
                                  <img src={detailData?.countryFlagPath} />
                                )}
                                <div>
                                  {detailData?.registrationCountryCode
                                    ? detailData?.registrationCountryCode
                                    : ""}
                                </div>
                              </div>
                              <Text
                                style={{ width: "100px" }}
                                ellipsis={{ tooltip: true }}
                              >
                                {detailData?.assetPlateNumber
                                  ? detailData?.assetPlateNumber
                                  : "NA"}
                              </Text>
                            </Space>
                          </Col>
                          <Col span={8}>
                            <span>{t("FLEET_TRUCKS_TRUCK_TYPE")}</span>
                            <span>
                              {detailData?.truckType
                                ? detailData?.truckType
                                : "NA"}
                            </span>
                          </Col>
                          <Col span={8}>
                            <span>{t("FLEET_TRUCKS_STATUS")}</span>{" "}
                            <div
                              className={
                                detailData?.statusText === "Available"
                                  ? t("AVAILABLE_STATUS_KEY")
                                  : detailData?.statusText === "Booked"
                                  ? t("BOOKED_STATUS_KEY")
                                  : t("WARNING_STATUS_KEY")
                              }
                            >
                              {detailData?.statusText
                                ? detailData?.statusText
                                : "NA"}
                            </div>
                          </Col>
                        </Row>
                        <Row gutter={[8, 8]} className="data-row">
                          <Col span={8}>
                            <span>{t("FLEET_TRUCKS_MANUFACTURING_YEAR")}</span>
                            <span>
                              {detailData?.manufacturingYear
                                ? detailData?.manufacturingYear
                                : "NA"}
                            </span>
                          </Col>
                          <Col span={8}>
                            <span>{t("FLEET_TRUCKS_REGISTRATION_CITY")}</span>
                            <span>
                              {detailData?.registrationCity
                                ? detailData?.registrationCity
                                : "NA"}
                            </span>
                          </Col>
                          <Col span={8}>
                            <span>{t("FLEET_TRUCKS_BRAND_NAME")}</span>
                            <span>
                              {detailData?.brandName
                                ? detailData?.brandName
                                : "NA"}
                            </span>
                          </Col>
                        </Row>
                        <Row gutter={[8, 8]} className="data-row">
                          <Col span={10}>
                            <span>
                              {t("FLEET_TRUCKS_NO_PLATE_ISSUER_NAME")}
                            </span>
                            <span>
                              {detailData?.plateNumberIssuerName
                                ? detailData?.plateNumberIssuerName
                                : "NA"}
                            </span>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Card>
              </Col>

              <Col span={12} className="flex-column">
                <Card
                  className="truck-fleet-card"
                  title={
                    <div className="card-title">
                      {t("FLEET_TRUCKS_UPLOADED_DOC")}
                    </div>
                  }
                  extra={
                    <Button
                      style={{
                        display: detailData?.canUpdated == false && "none",
                      }}
                      className="edit-btn"
                      icon={<img src={EditImg} />}
                      type="link"
                      onClick={() => setAddModalOpen(!addModalOpen)}
                    >
                      {t("FLEET_MANAGEMENT_EDIT")}
                    </Button>
                  }
                >
                  {fleetType === "Driver" ? (
                    <div className="doc-data">
                      {detailData?.nationalID === null &&
                      detailData?.passport === null &&
                      detailData?.visa?.length === 0 &&
                      detailData?.drivingLicense === null ? (
                        <Row justify={"center"} className="no-data">
                          <img src={NodataImg} alt="no data" />
                        </Row>
                      ) : (
                        <>
                          {driverDocs?.length > 0 &&
                            driverDocs?.map((item) => (
                              <div>
                                <Row gutter={16} className="data-row">
                                  <Col span={9}>
                                    <span className="trucks-span">
                                      {translatedKeys(item?.type)}
                                    </span>
                                  </Col>
                                  <Col span={13} className="doc-file">
                                    <Row justify={"end"}>
                                      <Col>
                                        {item.type === "Visa" && (
                                          <Fileupload
                                            defaultThumbFile={
                                              item?.frontDoc?.documentPath || ""
                                            }
                                            defaultFile={
                                              item?.frontDoc?.documentPath || ""
                                            }
                                            filetype={""}
                                            fileName={""}
                                            entityId=""
                                            entityType={""}
                                            accessFile={true}
                                            readonly={true}
                                          />
                                        )}
                                        {item.type !== "Visa" && (
                                          <div
                                            style={{
                                              display: "flex",
                                              gap: "10px",
                                            }}
                                          >
                                            {/* <img
                              src={item?.frontDoc?.documentPath || ""}
                              alt="Visa Document"
                            /> */}
                                            <Fileupload
                                              defaultThumbFile={
                                                item?.frontDoc?.documentPath ||
                                                ""
                                              }
                                              defaultFile={
                                                item?.frontDoc?.documentPath ||
                                                ""
                                              }
                                              filetype={""}
                                              fileName={""}
                                              entityId=""
                                              entityType={""}
                                              accessFile={true}
                                              readonly={true}
                                            />

                                            {/* <img
                              src={item?.backDoc?.documentPath || ""}
                              alt="Other Document"
                            /> */}

                                            <Fileupload
                                              defaultThumbFile={
                                                item?.backDoc?.documentPath ||
                                                ""
                                              }
                                              defaultFile={
                                                item?.backDoc?.documentPath ||
                                                ""
                                              }
                                              filetype={""}
                                              fileName={""}
                                              entityId=""
                                              entityType={""}
                                              accessFile={true}
                                              readonly={true}
                                            />
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                  </Col>

                                  {/* <Col span={2}>
                        <MoreOutlined style={{fontSize:"19px"}} />
                      </Col> */}
                                </Row>
                                <Row gutter={16} className="data-row">
                                  <Col span={12}>
                                    <span>{translatedKeys(item?.type)}</span>
                                    <span>
                                      {item?.documentNumber
                                        ? item?.documentNumber
                                        : "NA"}
                                    </span>
                                  </Col>
                                  <Col span={12}>
                                    <span>{t("FLEET_TRUCKS_EXPIRY_DATE")}</span>
                                    {item.type == "Visa" ? (
                                      <span>
                                        {item?.expiryDate
                                          ? moment(item?.expiryDate).format(
                                              "DD/MM/YYYY"
                                            )
                                          : "NA"}
                                      </span>
                                    ) : (
                                      <span>
                                        {item?.expiryDate
                                          ? moment(item?.expiryDate).format(
                                              "DD/MM/YYYY"
                                            )
                                          : "NA"}
                                      </span>
                                    )}
                                  </Col>
                                </Row>
                                <div className="bottom-border"></div>
                              </div>
                            ))}
                        </>
                      )}
                    </div>
                  ) : (
                    <div>
                      <Row gutter={16} className="data-row">
                        <Col span={9}>
                          <span className="trucks-span">
                            {t("FLEET_TRUCKS_RC_DOC")}
                          </span>
                        </Col>
                        <Col span={15} className="doc-file">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <div style={{ flex: "1" }}>
                              <Fileupload
                                defaultThumbFile={
                                  detailData?.regCertificate
                                    ? documentUtility.getThumbnailImagePath(
                                        detailData?.regCertificate?.frontDoc
                                          ?.documentPathThumb
                                      )
                                    : ""
                                }
                                defaultFile={
                                  detailData?.regCertificate
                                    ? detailData?.regCertificate?.frontDoc
                                        ?.documentPath
                                    : ""
                                }
                                filetype={""}
                                fileName={""}
                                entityId=""
                                entityType={""}
                                accessFile={true}
                                readonly={true}
                              />
                            </div>
                            <div style={{ flex: "1", paddingLeft: "8px" }}>
                              <Fileupload
                                defaultThumbFile={
                                  detailData?.regCertificate
                                    ? documentUtility.getThumbnailImagePath(
                                        detailData?.regCertificate?.backDoc
                                          ?.documentPathThumb
                                      )
                                    : ""
                                }
                                defaultFile={
                                  detailData?.regCertificate
                                    ? detailData?.regCertificate?.backDoc
                                        ?.documentPath
                                    : ""
                                }
                                filetype={""}
                                fileName={""}
                                entityId=""
                                entityType={""}
                                accessFile={true}
                                readonly={true}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row gutter={16} className="data-row">
                        <Col span={13}>
                          <span>{t("FLEET_TRUCKS_REGISTRATION_NO")}</span>
                          <span>
                            {detailData?.regCertificate
                              ? detailData?.regCertificate?.documentNumber
                              : "NA"}
                          </span>
                        </Col>
                        <Col span={11}>
                          <span>{t("FLEET_TRUCKS_EXPIRY_DATE")}</span>
                          <span>
                            {detailData?.regCertificate
                              ? moment(
                                  detailData?.regCertificate?.expiryDate
                                ).format("DD/MM/YYYY")
                              : "NA"}
                          </span>
                        </Col>
                      </Row>
                      <div className="bottom-border"></div>

                      {detailData?.isTrailerDocument ? (
                        <div>
                          <Row gutter={16} className="data-row">
                            <Col span={9}>
                              <span className="trucks-span">
                                {t("TRAILER_DOCUMENT_KEY")}
                              </span>
                            </Col>
                            <Col span={15} className="doc-file">
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <div style={{ flex: "1" }}>
                                  <Fileupload
                                    defaultThumbFile={
                                      detailData?.trailerRegCertificate
                                        ? documentUtility.getThumbnailImagePath(
                                            detailData?.trailerRegCertificate
                                              ?.frontDoc?.documentPath
                                          )
                                        : ""
                                    }
                                    defaultFile={
                                      detailData?.trailerRegCertificate
                                        ?.frontDoc?.documentPath
                                    }
                                    filetype={""}
                                    fileName={""}
                                    entityId=""
                                    entityType={""}
                                    accessFile={true}
                                    readonly={true}
                                  />
                                </div>
                                <div style={{ flex: "1", paddingLeft: "8px" }}>
                                  <Fileupload
                                    defaultThumbFile={
                                      detailData?.trailerRegCertificate
                                        ? documentUtility.getThumbnailImagePath(
                                            detailData?.trailerRegCertificate
                                              ?.backDoc?.documentPath
                                          )
                                        : ""
                                    }
                                    defaultFile={
                                      detailData?.trailerRegCertificate?.backDoc
                                        ?.documentPath
                                    }
                                    filetype={""}
                                    fileName={""}
                                    entityId=""
                                    entityType={""}
                                    accessFile={true}
                                    readonly={true}
                                  />
                                </div>
                              </div>
                            </Col>
                          </Row>

                          {/* 
                  <Row gutter={16} className="data-row">
                      <Col span={10}>
                          <span className="trucks-span">{t("FLEET_TRUCKS_TRAILER_REG_CERTIFICATE")}</span>
                      </Col>
                      <Col span={14} className="doc-file">
                      <Row justify={'end'}>
                      <img src={detailData?.trailerRegCertificate ? detailData?.trailerRegCertificate?.frontDoc?.documentPath : "NA"} alt="alt" />
                      <img src={detailData?.trailerRegCertificate ? detailData?.trailerRegCertificate?.backDoc?.documentPath : "NA"} alt="alt" />
                      </Row>
                      </Col>
                  </Row>                    */}
                          <Row gutter={16} className="data-row">
                            <Col span={13}>
                              <span>{t("FLEET_TRUCKS_REGISTRATION_NO")}</span>
                              <span>
                                {detailData?.trailerRegCertificate
                                  ? detailData?.trailerRegCertificate
                                      ?.documentNumber
                                  : "NA"}
                              </span>
                            </Col>
                            <Col span={11}>
                              <span>{t("FLEET_TRUCKS_EXPIRY_DATE")}</span>
                              <span>
                                {detailData?.trailerRegCertificate
                                  ? moment(
                                      detailData?.trailerRegCertificate
                                        ?.expiryDate
                                    ).format("DD/MM/YYYY")
                                  : "NA"}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      ) : (
                        <div></div>
                      )}
                    </div>
                  )}
                </Card>
              </Col>
            </Row>

            <Row className="table-title">
              <span className="Trips-title">{t("FLEET_TRUCKS_TRIPS")}</span>
              <span onClick={() => setTableToggle(!tableToggle)}>
                <img src={tableToggle ? Arrowdown : ArrowUp} />
              </span>
            </Row>
            <div
              className={
                tableToggle ? "table-toggle-close" : "table-toggle-open"
              }
            >
              <Row justify={"space-between"} className="search-row">
                <h3 className="card-title"></h3>
                <Space>
                  <Input
                    placeholder={t("FLEET_SEARCH_PH")}
                    prefix={<SearchOutlined />}
                    className="input"
                    onChange={handleSearch}
                  />
                  <img src={sortImg} alt="alt" onClick={handleSort} />
                </Space>
              </Row>
              <Table
                columns={columns}
                dataSource={tripTableData}
                rowKey="orderId"
                loading={triptableLoader}
                pagination={{
                  total: tripdetialListPagination.totalRecord,
                  current: tripdetialListPagination.currentPage,
                  pageSize: pageSize,
                  showSizeChanger: false,
                }}
                className="table"
              />
            </div>

            {addModalOpen && fleetType === "Truck" && (
              <AddTruck
                isOpen={addModalOpen}
                onClose={handleCloseModal}
                formType={"editForm"}
                editformValues={detailData}
                refresh={getData}
                supplierId={supplierId}
                supplierCountry={user?.operatingCountry}
                setIsUploadingPopupVisible={setIsUploadingPopupVisible}
                setUploadState={setUploadState}
              />
            )}
            {addModalOpen && fleetType === "Driver" && (
              <AddDriver
                isOpen={addModalOpen}
                onClose={handleCloseModal}
                formType={"editForm"}
                editformValues={detailData}
                refresh={getData}
                supplierId={supplierId}
                supplierCountry={user?.operatingCountry}
                setIsUploadingPopupVisible={setIsUploadingPopupVisible}
                setUploadState={setUploadState}
              />
            )}
          </div>
        )}
        {verifyModal && (
          <Modal
            open={verifyModal}
            centered
            maskClosable={false}
            onCancel={() => {
              setVerifyModal(false);
            }}
            width={"30rem"}
            title={
              <Row justify={"center"} style={{ fontSize: "18px" }}>
                {t("OTP_VERIFICATION_KEY")}
              </Row>
            }
            footer={false}
          >
            <div className="verify-modal-wrapper">
              <Form>
                <Row justify={"center"}>
                  <Col span={7} style={{ paddingRight: "10px" }}>
                    <Form.Item
                      rules={[
                        { required: true, message: t("COUNTRY_CODE_REQUIRED") },
                      ]}
                      name="countryCode"
                      className="floating-label-form-item"
                    >
                      <Select
                        showSearch
                        className="floating-select country-code-select"
                        popupClassName="country-code-popup"
                        placeholder="+355"
                        disabled={true}
                        value={detailData?.countryCode}
                        fieldNames={{
                          label: "label",
                          value: "phone_code",
                        }}
                      />
                      <label className="floating-label">
                        {t("COUNTRY_CODE_LBL")}{" "}
                        <b className="mandate-color">*</b>
                      </label>
                    </Form.Item>
                  </Col>
                  <Col span={17}>
                    <Form.Item
                      rules={[
                        { required: true, message: t("MOBILE_NO_REQUIRED") },
                        {
                          pattern: /^[0-9]*$/,
                          message: t("MOBILE_NO_VALIDATION_REQUIRED"),
                        },
                      ]}
                      name="mobileNumber"
                      className="floating-label-form-item"
                    >
                      <Input
                        placeholder={t("FORGOT_PH_MOBILE_NO")}
                        value={detailData?.mobileNumber}
                        disabled={true}
                        className="floating-input-basic"
                      />
                      <label className="floating-label">
                        {t("FORGOT_LBL_MOBILE_NO")}{" "}
                        <b className="mandate-color">*</b>
                      </label>
                    </Form.Item>
                  </Col>
                </Row>
                <div className="four-digit">{t("ENTER_FOUR_DIGIT_OTP")}</div>
                <Form.Item
                  name="otpNumber"
                  rules={[{ required: true, message: t("PIN_REQUIRED") }]}
                >
                  <Input.OTP
                    style={{ width: "150px" }}
                    length={4}
                    onChange={(e) => handleFormChange("otpNumber", e)}
                  />
                </Form.Item>
                {isOTPRequested && (
                  <span onClick={onResendOTP} className={"resend-otp"}>
                    {timer === 0 ? "Resend OTP" : `Resend OTP in ${timer}s`}
                  </span>
                )}
              </Form>
              <div className="button-row">
                <Button
                  type="secondary"
                  className="cancel-btn"
                  onClick={() => {
                    setVerifyModal(false);
                  }}
                >
                  {" "}
                  {t("COMMON_CANCEL_BTN")}
                </Button>
                <Button
                  type="secondary"
                  loading={btnLoader}
                  className="submit-btn"
                  onClick={verifyOTPHandler}
                >
                  {t("VERIFY_KEY")}
                </Button>
              </div>
            </div>
          </Modal>
        )}
        <Modal
          className="change-mobile-modal"
          title={
            <div style={{ fontWeight: "bold", fontSize: "20px" }}>
              {t("UPLOAD_PROFILE_PIC_KEY")}
            </div>
          }
          open={isUploadImage}
          onCancel={() => setIsUploadImage(false)}
          footer={false}
        >
          <br />

          <Form form={uploadImageForm} name="uploadImageForm">
            <Form.Item
              name="uploadImage"
              className="floating-label-form-item"
              rules={[{ required: true, message: t("UPLOAD_PROFILE_PIC_MSG") }]}
            >
              <Fileupload
                defaultThumbFile={documentUtility.getThumbnailImagePath(
                  uploadImageForm.getFieldValue("uploadImage")?.fileThumbUrl
                )}
                defaultFile={
                  uploadImageForm.getFieldValue("uploadImage")?.fileUrl
                }
                filetype={DocTypes?.PROFILE_PIC}
                fileName={
                  uploadImageForm.getFieldValue("uploadImage")?.fileName
                }
                entityId=""
                entityType={EntityTypes.SUPPLIER}
                accessFile={true}
                name={t("KYC_UPLOAD_FRONT_LBL")}
                onChange={(value) => {
                  onProfilePictureUpload(value, "uploadImage");
                  //kycForm.setFieldsValue({ licenceFront: value });
                }}
                // updateFormValue={(val)=>{ kycForm.setFieldsValue({ licenceFront: val })}}
              />
            </Form.Item>
          </Form>

          <div className="mobile-change-footer">
            <Button
              className="mobile-change-button"
              key="cancel"
              disabled={imageUploadLoader}
              onClick={() => setIsUploadImage(false)}
            >
              {t("COMMON_CANCEL_BTN")}
            </Button>
            <Button
              className="mobile-change-button"
              loading={imageUploadLoader}
              key="submit"
              type="primary"
              onClick={handleUploadProfile}
            >
              {t("COMMON_SUBMIT_BTN")}
            </Button>
          </div>
        </Modal>
      </div>
      <Modal
        open={isUploadingPopupVisible}
        footer={null}
        closable={false}
        // onCancel={() => setIsUploadingPopupVisible(false)}
        centered
        width={352}
        style={{
          textAlign: "center",
          padding: "32px 16px",
          zIndex: "2000000 !important",
          position: "relative",
        }}
      >
        <h3
          style={{
            fontWeight: "600",
            fontSize: "18px",
            lineHeight: "1.5",
            margin: 0,
          }}
        >
          {t("OCR_MODAL_UPLOADING_PROCESSING_DOC")}
        </h3>
        <div style={{ margin: "12px 0" }}>
          <img
            // src={logo}
            src={fileSearchGif}
            alt="File Search"
            style={{ width: 112, height: 112 }}
          ></img>
        </div>

        <p
          style={{
            fontWeight: "500",
            fontSize: "14px",
            margin: 0,
            color: "var(--text-muted, #2C3A4BE5)",
          }}
        >
          {uploadState.status}
        </p>
        <p
          style={{
            color: "var(--text, #394452)",
            fontSize: "12px",
            marginTop: "8px",
            marginBottom: 0,
            color: "var(--text-muted, #394452CC)",
          }}
        >
          {uploadState.description}
        </p>
      </Modal>
    </>
  );
};
export default FleetDetails;
